import React, {Component} from 'react';
import LoadingComponent from "../../common/loadingComponent";
import {Redirect} from "react-router-dom";
import httpService from "../../../../services/httpService";
import {getMatchAllUsers} from "../../../../services/matchUsersService";
import FicheMatchUser from "../../dataDisplay/FicheMatchUser";
import {getCountryList} from "../../../../services/countryService";
import {getFacultyList} from "../../../../services/facultyService";
import {getInterestsList} from "../../../../services/interestsService";
import {getLanguagesList} from "../../../../services/languagesService";
import {getPreferencesList} from "../../../../services/preferencesService";
import {getReferencesList} from "../../../../services/referencesService";
import "./PairingPageContent.css"
import {getSessionsList} from "../../../../services/sessionsService";
import ExcelJsExportButton from "../../../utility/ExcelJSExport/ExcelJSExport";

class PairingPageContent extends Component {

    _isMounted = false;

    state = {
        RedirectToLoginPage:false,
        isLoading : false,
        activeMatchKey: null,
        countryList : {},
        facultyList : {},
        interestsList : {},
        sessionsList : {},
        languagesList : {},
        studyLevelList : [{id:0, name: "Premier cycle (certificat, baccalauréat)"},{id:1, name: "Deuxième cycle (Maîtrise, DESS)"},{id:2, name: "Troisième cycle (Doctorat)"}],
        preferencesList : {},
        referencesList : {},
        matches : {},
        locale : this.props.locale
    };

    componentDidMount() {
        this._isMounted = true;
        this.onLoadPage();
    }

    onLoadPage = async () =>{
        try {
            this.setState({isLoading:true});

            const [
                {data: countryList},
                {data: matches},
                {data: facultyList},
                {data: interestsList},
                {data: sessionsList},
                {data: languagesList},
                {data: preferencesList},
                {data: referencesList},
            ] = await httpService.all([
                getCountryList('fr'),
                getMatchAllUsers(),
                getFacultyList('fr'),
                getInterestsList('fr'),
                getSessionsList('fr'),
                getLanguagesList('fr'),
                getPreferencesList('fr'),
                getReferencesList('fr'),
            ]);
            if (this._isMounted){
                this.setState({
                    countryList,
                    matches,
                    facultyList,
                    interestsList,
                    sessionsList,
                    languagesList,
                    preferencesList,
                    referencesList,
                    isLoading: false
                });
            }

        }  catch(err)  {
            console.log("Error loading API")
            if (this._isMounted){
                this.setState({isLoading: false, RedirectToLoginPage:true});
            }
        }
    }

    // <DownloadExcelFile />

    toggleMatch = (matchKey) => {
        this.setState((prevState) => ({
            activeMatchKey: prevState.activeMatchKey === matchKey ? null : matchKey
        }));
    }

    renderMatches = (matches) => {
        if(matches.length > 0){
            return(
                matches.map((value, key) => (
                    <article className={`pairingAccordionItem ${this.state.activeMatchKey === key ? "open" : ""}`} key={key}>
                        <button
                            type="button"
                            className="pairingAccordionTrigger"
                            onClick={() => this.toggleMatch(key)}
                            aria-expanded={this.state.activeMatchKey === key}
                        >
                            <span className="pairingMatchIndex">Jumelage #{key + 1}</span>
                            <span className="pairingMatchUsers">{value.client.firstName} {value.client.lastName}{" -> "}{value.sponsor.firstName} {value.sponsor.lastName}</span>
                            <span className="pairingAccordionCta">{this.state.activeMatchKey === key ? "Masquer" : "Voir le détail"}</span>
                        </button>

                        {this.state.activeMatchKey === key &&
                        <div className="pairingAccordionPanel">
                            <div className="pairingRoleRow">
                                <span className="pairingRoleTag">Étudiant</span>
                                <span className="pairingRoleTag">Parrain/Marraine</span>
                            </div>

                            <div className="row pairingMatchBody">
                                <div className="col-md-6 pairingMatchSide">
                                    <FicheMatchUser
                                        data={value.client}
                                        facultyList={this.state.facultyList}
                                        countryList={this.state.countryList}
                                        languageList={this.state.languagesList}
                                        preferencesList={this.state.preferencesList}
                                        interestsList={this.state.interestsList}
                                        sessionsList={this.state.sessionsList}
                                        studyLevelList={this.state.studyLevelList}
                                        compact={true}
                                    />
                                </div>

                                <div className="col-md-6 pairingMatchSide">
                                    <FicheMatchUser
                                        data={value.sponsor}
                                        facultyList={this.state.facultyList}
                                        countryList={this.state.countryList}
                                        languageList={this.state.languagesList}
                                        preferencesList={this.state.preferencesList}
                                        interestsList={this.state.interestsList}
                                        sessionsList={this.state.sessionsList}
                                        studyLevelList={this.state.studyLevelList}
                                        forceFooter="Parrain/Marraine attitré(e)"
                                        compact={true}
                                    />
                                </div>
                            </div>
                        </div>
                        }
                    </article>
                ))
            )
        }
        else{
            return(
                <div className="pairingEmptyState">
                    <h2>Aucun match à afficher</h2>
                    <p>Lorsque des jumelages seront créés, ils apparaîtront ici.</p>
                </div>
            )
        }

    }

    renderPage = (matches) => {

        if (this._isMounted){
            return (
                <div className="pairingPage">
                    <div className="pairingPageHeader">
                        <div>
                            <h1>Résumé des matchs actuels</h1>
                            <p className="pairingPageSubtitle">Vue consolidée des jumelages étudiant-parrain en cours.</p>
                        </div>

                        <div className="pairingPageToolbar">
                            <span className="pairingCountBadge">{matches.length} jumelage(s)</span>

                            <ExcelJsExportButton
                                matchesList = {this.state.matches}
                                facultyList={this.state.facultyList}
                                countryList={this.state.countryList}
                                languageList={this.state.languagesList}
                                preferencesList={this.state.preferencesList}
                                referencesList={this.state.referencesList}
                                interestsList={this.state.interestsList}
                            />
                        </div>
                    </div>

                    <div className="pairingMatchesList">
                        {this.renderMatches(matches)}
                    </div>
                </div>
            );
        }

    }

    render() {

        if (this.state.RedirectToLoginPage) {
            const loginPage = `/${this.state.locale}/login`
            return <Redirect to={loginPage}  />
        }

        return (
            <>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            {this.state.isLoading ? <LoadingComponent/> : this.renderPage(this.state.matches)}
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default PairingPageContent;